export default function() {
    return (
        <div className="footer">
            
        </div>
    ) 
}